import React, { useEffect, useCallback, useContext, useState } from "react";
import { Link, Route, useHistory } from "react-router-dom";
import { clearDbIndex, listDbIndex } from "../lib/comm";
import {
  MainContext,
  STATUS_ONLINE,
  STATUS_SYNCED,
  UIContext,
  UpdateContext,
} from "../main-context";
import Sidebar from "./Sidebar";
import jflogo from "../assets/img/jflogo.jpg";
import natalogo from "../assets/img/natalogo.jpg";
import menu_css from "./offline.module.css";
import { main } from "../main-context";
import OfflineBar from "./helpers/OfflineBar";
import LoadBar from "./helpers/LoadBar";
import Modal from "./helpers/Modal";
import Filter from "./Filter";

export default function Menu() {
  const [filterOpen, setFilterOpen] = useState(false);
  const history = useHistory();
  const update_context = useContext(UpdateContext);
  const logout = useCallback(() => {
    clearDbIndex()
      .then(() => {
        update_context.update_main_context(main);
        history.push(update_context.settings.subfolder);
      })
      .catch((error) =>
        update_context.update_ui_context((prev) => ({ ...prev, error: error }))
      );
  }, [history, update_context]);
  useEffect(() => {
    window.big_slide_load();
  }, []);
  return (
    <UIContext.Consumer>
      {({ modal, online_status }) => (
        <MainContext.Consumer>
          {({ status, constants, groups }) => (
            <>
              <Modal
                header={modal.header}
                url={modal.url}
                footerType={modal.footerType}
                errorHtml={modal.errorHtml}
              ></Modal>
              <div className="navbar navbar-inverse navbar-fixed-top">
                <div className="container nav-container">
                  <div className="">
                    <ul className="list-unstyled list-inline navbar-jf-admin pull-right">
                      <li>
                        <div
                          className="navdrawer-link"
                          style={{ cursor: "pointer" }}
                        >
                          MENU
                        </div>

                        <nav
                          id="navdrawer"
                          role="navigation"
                          className={"panel " + menu_css["menu-nav-class"]}
                        >
                          <div className="close bgd-dark bigslide-close">✕</div>
                          <ul>
                            <li className="profile bgd-dark">
                              {(status.photo && (
                                <div
                                  className="user-photo img-jf-border"
                                  style={{
                                    background:
                                      "url(data:image/gif;base64," +
                                      status.photo +
                                      ")",
                                  }}
                                  alt=""
                                ></div>
                              )) || (
                                <div
                                  className={
                                    "user-photo img-jf-border " +
                                    menu_css["menu-no-photo"]
                                  }
                                  alt=""
                                ></div>
                              )}

                              <table>
                                <tbody>
                                  <tr>
                                    <td colSpan="2" className="name">
                                      {status.get_full_name}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td colSpan="2">
                                      {(online_status === STATUS_ONLINE && (
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/online-only/profile/edit"
                                          }
                                        >
                                          Update Profile
                                        </Link>
                                      )) || (
                                        <span
                                          style={{
                                            color: "lightgray",
                                          }}
                                        >
                                          Update Profile
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                  <tr className="bottomrow">
                                    <td colSpan="2">
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => logout()}
                                      >
                                        Logout
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </li>

                            <li>
                              <Link
                                to={update_context.settings.subfolder + "/home"}
                              >
                                Home
                              </Link>
                            </li>

                            {!(
                              status.has_station == null &&
                              [
                                constants.VENDOR_ADMINS,
                                constants.AIRLINES,
                              ].indexOf(status.group.name) !== -1
                            ) && (
                              <>
                                <>
                                  <>
                                    {status.group.name ===
                                      constants.VENDOR_ADMINS && (
                                      <li>
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/overview"
                                          }
                                        >
                                          Station Overview
                                        </Link>
                                      </li>
                                    )}
                                  </>
                                  <>
                                    {status.group.name !==
                                      constants.AIRPORTAUTHORITY && (
                                      <li>
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/inspections/daily"
                                          }
                                        >
                                          Daily Inspections
                                        </Link>
                                      </li>
                                    )}
                                  </>
                                  <>
                                    {status.group.name ===
                                      constants.FUELERS && (
                                      <>
                                        <li>
                                          <Link
                                            to={
                                              update_context.settings
                                                .subfolder +
                                              "/inspections/weekly"
                                            }
                                          >
                                            Weekly Inspections
                                          </Link>
                                        </li>
                                        <li>
                                          {(online_status === STATUS_ONLINE && (
                                            <Link
                                              to={
                                                update_context.settings
                                                  .subfolder +
                                                "/online-only/users/leaderboard/weekly"
                                              }
                                            >
                                              Leaderboard
                                            </Link>
                                          )) || (
                                            <span
                                              style={{
                                                display: "block",
                                                padding: "10px 0px 10px 0px",
                                                color: "lightgray",
                                              }}
                                            >
                                              Leaderboard
                                            </span>
                                          )}
                                        </li>
                                      </>
                                    )}
                                  </>
                                </>
                                <>
                                  {status.group.priority >=
                                    groups[constants.MAINTAINERS] && (
                                    <>
                                      <li>
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/inspections/weekly"
                                          }
                                        >
                                          Weekly Inspections
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/inspections/maintenance"
                                          }
                                        >
                                          MX Dashboard
                                        </Link>
                                      </li>
                                      <li>
                                        {(online_status === STATUS_ONLINE && (
                                          <Link
                                            to={
                                              update_context.settings
                                                .subfolder +
                                              "/online-only/equipment"
                                            }
                                          >
                                            Equipment Records
                                          </Link>
                                        )) || (
                                          <span
                                            style={{
                                              display: "block",
                                              padding: "10px 0px 10px 0px",
                                              color: "lightgray",
                                            }}
                                          >
                                            Equipment Records
                                          </span>
                                        )}
                                      </li>
                                      <li>
                                        {(online_status === STATUS_ONLINE && (
                                          <Link
                                            to={
                                              update_context.settings
                                                .subfolder +
                                              "/online-only/maintenance"
                                            }
                                          >
                                            Discrepancy Log
                                          </Link>
                                        )) || (
                                          <span
                                            style={{
                                              display: "block",
                                              padding: "10px 0px 10px 0px",
                                              color: "lightgray",
                                            }}
                                          >
                                            Discrepancy Log
                                          </span>
                                        )}
                                      </li>
                                      <li>
                                        <Link
                                          to={
                                            update_context.settings.subfolder +
                                            "/inspections/fso"
                                          }
                                        >
                                          Safety Observations
                                        </Link>
                                      </li>
                                    </>
                                  )}
                                </>
                                <>
                                  {status.group.priority >=
                                    groups[constants.ADMINS] && (
                                    <>
                                      <li>
                                        {(online_status === STATUS_ONLINE && (
                                          <Link
                                            to={
                                              update_context.settings
                                                .subfolder +
                                              "/online-only/users"
                                            }
                                          >
                                            User Management
                                          </Link>
                                        )) || (
                                          <span
                                            style={{
                                              display: "block",
                                              padding: "10px 0px 10px 0px",
                                              color: "lightgray",
                                            }}
                                          >
                                            User Management
                                          </span>
                                        )}
                                      </li>
                                      <li>
                                        {(online_status === STATUS_ONLINE && (
                                          <Link
                                            to={
                                              update_context.settings
                                                .subfolder +
                                              "/signatureRoster/signatureRoster"
                                            }
                                          >
                                            Signature Roster
                                          </Link>
                                        )) || (
                                          <span
                                            style={{
                                              display: "block",
                                              padding: "10px 0px 10px 0px",
                                              color: "lightgray",
                                            }}
                                          >
                                            Signature Roster
                                          </span>
                                        )}
                                      </li>
                                    </>
                                  )}
                                </>
                              </>
                            )}
                          </ul>
                        </nav>
                      </li>
                    </ul>
                    {/* TODO @if($perms->groupIsAtLeast(UserGroups::ADMINS))
                @include('layouts.equipmentLookup')
                @endif */}
                    <Link to={update_context.settings.subfolder + "/home"}>
                      {(!status.is_nata_user && (
                        <img
                          src={jflogo}
                          alt="headerlogo"
                          className="headerlogo"
                        />
                      )) || (
                        <img
                          src={natalogo}
                          alt="headerlogo"
                          className="headerlogo"
                        />
                      )}
                    </Link>
                  </div>
                </div>
                <div className="bgd-dark">
                  <div className="container">
                    <div className="row centered row-info">
                      <div className="hidden-xs hidden-sm  col-sm-3 col-sm-4 col-md-4 ffcol menu-pt-4">
                        {status.get_full_name}
                      </div>
                      <div className="col-xs-12 col-sm-4 col-md-2 ffcol menu-pt-4">
                        {status.can_change_prefs && (
                          <div
                            className={`compact-filter ${
                              filterOpen ? "force-hide" : ""
                            }`}
                          >
                            <span
                              className="anchor change"
                              onClick={() => setFilterOpen(true)}
                            >
                              <span>filter settings</span>&nbsp;▾
                            </span>
                          </div>
                        )}
                        <div className="visible-xs visible-sm home-name ">
                          {status.get_full_name}
                        </div>
                        <div className="home-date">{status.date_string}</div>
                      </div>
                      <div className="col-xs-12 col-sm-8 col-md-6">
                        {status.can_change_prefs && (
                          <Filter
                            filterOpen={filterOpen}
                            setFilterOpen={setFilterOpen}
                          ></Filter>
                        )}
                        <Sidebar></Sidebar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={menu_css["offline-bar"]}>
                <OfflineBar></OfflineBar>
                <Route
                  exact
                  path={
                    update_context.settings.subfolder + "/inspections/:type"
                  }
                >
                  {online_status !== STATUS_SYNCED && <LoadBar></LoadBar>}
                </Route>
              </div>
            </>
          )}
        </MainContext.Consumer>
      )}
    </UIContext.Consumer>
  );
}
